module.exports = __webpack_public_path__ + "assets/img/组 2@2x.0b11dc39.png";